var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlob3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 678 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357 47.5003C419.803 52.4245 472 7.5 545.5 1.00025C614.5 1.00025 626.238 -1.32618 666.5 57.0001C710.837 121.23 601.5 217.5 633.5 295.5C665.5 373.5 643 423.5 643 423.5C643 423.5 599 560.5 446 511.5C403.5 495 255 474.5 167.5 511.5C91.9273 543.456 57.0401 528 31.5003 474.5C-4.20662 399.702 81.697 385.046 79.5 301.5C77.6501 231.156 42 223 18.0366 155.5C-16.4996 100 0.422146 50.3361 60.5 15.5002C117.981 -17.8301 291.437 42.3597 357 47.5003Z",
    fill: "#F3E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/Blob3.8c52d196d4c89e1f5f85571047619a40.svg";
export { ForwardRef as ReactComponent };